"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableKpiHeadline = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var presentationComponents_1 = require("../../../presentationComponents");
var EditableHeadline_1 = require("../../common/EditableHeadline");
var MAX_KPI_TITLE_LENGTH = 35;
exports.EditableKpiHeadline = function (_a) {
    var title = _a.title, onTitleChange = _a.onTitleChange, onTitleEditingEnd = _a.onTitleEditingEnd, onTitleEditingStart = _a.onTitleEditingStart, clientHeight = _a.clientHeight;
    var maxLength = Math.max(title.length, MAX_KPI_TITLE_LENGTH);
    return (react_1.default.createElement(presentationComponents_1.DashboardItemHeadlineContainer, { clientHeight: clientHeight },
        react_1.default.createElement(EditableHeadline_1.EditableHeadline, { text: title, originalTitle: title, maxLength: maxLength, onTitleChange: onTitleChange, onTitleEditingStart: onTitleEditingStart, onTitleEditingCancel: onTitleEditingEnd })));
};
//# sourceMappingURL=EditModeKpiHeadline.js.map